import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

export const managementAppReadOnlyPolicy = defineBuiltinPolicy({
  key: 'builtin:management-app-read-only',
  name: 'Management App Read Only',
  description: 'View-only access to the management app.',
  actions: [
    PolicyActionEnum.ConsoleAccess,
    PolicyActionEnum.AccountView,
    PolicyActionEnum.AgentView,
    PolicyActionEnum.ApplicationView,
    PolicyActionEnum.AuditLogView,
    PolicyActionEnum.BrandView,
    PolicyActionEnum.DataSourceView,
    PolicyActionEnum.FormView,
    PolicyActionEnum.PromptView,
    PolicyActionEnum.RoleView,
    PolicyActionEnum.ToolView,
    PolicyActionEnum.UnmetNeedView,
    PolicyActionEnum.UserView,
  ],
});
